import * as React from 'react';
import { RouteComponentProps, Prompt } from 'react-router-dom';
import { Input } from '@progress/kendo-react-inputs';
import { fetchApi } from '../../services/api';
import LoadingButton from '../LoadingButton';
const DocumentTitle = require('react-document-title');

type Props = RouteComponentProps<{}>

type State = {
    isLoading: boolean;
    isDirty: boolean;
    Validation: boolean;

    tenant: TenantData|undefined;
}

type TenantData = {
    TenantName: string;
    DisplayName: string;
    FacebookURL: string
}

class TenantProfile extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            isLoading: true,
            isDirty: false,
            Validation: false,
            tenant: undefined,
        }

        this.save = this.save.bind(this);
    }

    public componentWillMount() {
        // This method runs when the component is first added to the page
        this.requestTenant();
    }

    public render() {
        return <form>
            <h1>Company Profile</h1>
            {this.state.tenant &&
                <div className="k-form">
                    <DocumentTitle title={this.state.tenant.DisplayName || "Company Profile"} />
                    <Prompt when={this.state.isDirty} message="Unsaved changes will be lost, are you sure?" />
                    {this.state.isLoading && <div className="k-loading-image"></div>}
                    <label className="k-form-field">
                        <span>Company Name</span>
                        <Input
                            type="text"
                            placeholder="Company Name"
                            value={this.state.tenant.DisplayName}
                            onChange={(e) => this.updateTenantState({ DisplayName: e.target.value })}
                        />
                        {this.state.Validation && !this.state.tenant.DisplayName && <p className="error-msg">DisplayName is Required</p>}
                    </label>
                    <label className="k-form-field">
                        <span>Facebook Page</span>
                        <Input
                            type="url"
                            placeholder="https://www.facebook.com/your-page-here"
                            value={this.state.tenant.FacebookURL}
                            onChange={(e) => this.updateTenantState({ FacebookURL: e.target.value })}
                        />
                    </label>
                    <div className="text-right">
                        <LoadingButton
                            onClick={this.save}
                            disabled={!this.state.isDirty}
                            isLoading={this.state.isLoading}
                            isLoadingText="Saving..."
                            className="btn btn-primary"
                        >
                            Save
                        </LoadingButton>
                    </div>
                </div>
            }
        </form>;
    }

    private updateTenantState(value: Partial<TenantData>) {
        const tenant = Object.assign({}, this.state.tenant, value);
        this.setState({ tenant, isDirty: true });
    }

    private requestTenant() {
        this.setState({ isLoading: true });
        fetchApi(`api/Tenant/Get`)
            .then((tenant: TenantData) => {
                this.setState({ isLoading: false, tenant });
            });
    }

    private save(e: React.MouseEvent<HTMLButtonElement>) {
        e.preventDefault();

        if (this.state.tenant) {
            this.setState({ isLoading: true, Validation: true });
            if (this.state.tenant.DisplayName) {
                fetchApi(`api/Tenant/Save`, this.state.tenant, 'POST')
                    .then(() => {
                        this.setState({ isLoading: false, isDirty: false });
                    })
            }
        }
    }
}

export default TenantProfile;
